import { Box, Divider, LinearProgress } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { Nullable } from 'common-types';
import OxSlider from '../../../../elements/OxSlider/OxSlider';
import config from '../../config/issues-config.json';
import FiltersFormContainer from '../../../../elements/FiltersForm/FiltersForm';
import { FilterIssueType, Filter, SearchInput } from '../../types/issues-types';
import FilterBox from '../../../../elements/FilterBox/FilterBox';
import FilterSearch from '../../../../elements/FilterFormItem/FilterSearch';
import {
  FilterType,
  FilterTypeToFilter,
  usingAtlasSearch,
} from '../../../../common/filters-utils/filters-utils';
import { AsyncLoadingState, LoadingStatus } from 'async-utils';

const IssuesSidebar: FC<React.PropsWithChildren<IssuesSidebarProps>> = ({
  issuesFilters,
  totalIssues,
  searchValues,
  issuesFiltersTypeSearch,
  issuesFiltersType,
  children,
  filterList,
  sliderValuePriority,
  setSliderValuePriority,
  loadingFilters,
  onChangeFilter,
  onChangeSliderFilter,
  handleSearchFilterType,
  handleClearFilter,
  isIssues,
}) => {
  return (
    <Box
      ml={2}
      width={config.sidebar.expandedSize}
      display='flex'
      flexDirection='column'
      gap={1.2}>
      {children}
      {loadingFilters.status === LoadingStatus.Pending ? (
        <LinearProgress sx={{ maxHeight: '1px' }} />
      ) : (
        <Divider sx={{ visibility: 'hidden' }} />
      )}

      {issuesFilters.map(filter => {
        if (
          filter.type === FilterTypeToFilter.BusinessPriority &&
          issuesFiltersType &&
          issuesFiltersTypeSearch
        ) {
          return (
            <FilterBox
              key={filter.header}
              header={FilterType.appBusinessPriority}
              filtersNumber={
                filterList[FilterTypeToFilter.BusinessPriority] && 1
              }>
              <Box px={4} py={2}>
                <OxSlider
                  sliderValue={sliderValuePriority}
                  setSliderValue={setSliderValuePriority}
                  value={[0, 100]}
                  minDistance={20}
                  valueLabelDisplay='auto'
                  ticks={[
                    100, 20, 90, 80, 70, 50, 40, 30, 60, 20, 10, 30, 40, 100,
                    10, 80, 20, 90, 100,
                  ]}
                  filterName={FilterTypeToFilter.BusinessPriority}
                  maxVal={100}
                  handleChangeFilterSlider={onChangeSliderFilter}
                />
              </Box>
            </FilterBox>
          );
        }
        const index = searchValues.findIndex(
          key => key.fieldName === filter.type,
        );
        return issuesFiltersType &&
          issuesFiltersTypeSearch &&
          usingAtlasSearch(
            issuesFiltersType,
            totalIssues,
            filter,
            searchValues,
            issuesFiltersTypeSearch,
          ) ? (
          <FilterBox
            key={filter.header}
            header={filter.header}
            filtersNumber={filterList[filter.type]?.length}
            type={filter.type}
            handleClear={handleClearFilter}>
            {filter.searchType && (
              <FilterSearch
                searchValue={searchValues[index]?.value}
                onSearch={handleSearchFilterType}
                filterType={filter.searchType}
              />
            )}
            <FiltersFormContainer
              filterByList={issuesFiltersTypeSearch[filter.type]}
              filterByListTemp={issuesFiltersType[filter.type]}
              filterTypeToFilterBy={filter.type}
              onChangeFilter={onChangeFilter}
              filterList={filterList}
              itemHeight={config.filters.itemHeight}
              maxHeight={config.filters.maxHeight}
              isIssues={isIssues}
            />
          </FilterBox>
        ) : null;
      })}
    </Box>
  );
};

export interface IssuesSidebarProps {
  totalIssues: number;
  issuesFiltersTypeSearch?: Nullable<FilterIssueType>;
  filterList: {};
  searchValues: SearchInput[];
  sliderValuePriority: number[];
  setSliderValuePriority: (newValue: number[]) => void;
  loadingFilters: AsyncLoadingState;
  issuesFiltersType: Nullable<FilterIssueType>;
  onChangeFilter: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeSliderFilter: (
    range: number | number[],
    filterName: FilterTypeToFilter,
  ) => void;
  issuesFilters: Filter[];
  handleSearchFilterType: (searchInput: string, type: string) => void;
  handleClearFilter?: (type: string) => void;
  isIssues?: boolean;
}

export default IssuesSidebar;
